import $ from "jquery";
import { COVID_SR_MESSAGE, CT_VALIDATION_MESSAGE, REPORT_TITLE } from "../../../constants/Constants";
import { covidReportState } from "./initialData";

let ctSeverityScore = 0;
let severity = "";
let selectedCorad = "";
let sectionSelected = "";
let sectionSelectedName = "";
var sentences;
var covidSRTemplateId;

export const  defaultValueSetHRCTCovidChest = () => {

    let allBlurEle = document.getElementsByClassName("severity-score-text");
    console.log("Element are");
    console.log(allBlurEle);

    for(let i=0;i<allBlurEle.length;i++){
        allBlurEle[i].onblur = function(){
            let sum = 0;
            $(".severity-score-text").each(function () {
                sum = sum + parseInt($(this).val());
            });
            ctSeverityScore = sum;
            $('#total-severity-score').val(sum);
        };
    }

   

    $("#sectionA_btn").prop('disable', 'true');
    $("#sectionB_btn").prop('disable', 'true');
    $('#title').css('padding-left','25px');
    $(".multiple-patchy-areas input[type=checkbox]").prop("disabled", false);
      $(".fluffy-subpleural-peribronchiolar input[type=checkbox]").prop("disabled", true);
      $(".severity-score-text").prop('disabled', true);
  
      $('#sectionB-visualized-lung-parenchyma').change(function () {
          if (this.checked) {
              $(".severity-score-text").val(0);
              $("#total-severity-score").val(0);
              $("input:radio[name='sectionA-findings']").each(function (i) {
                  this.checked = false;
              });
              $("input:radio[name='Reverse halo sign or other signs of organizing pneumonia is']").each(function (i) {
                  this.checked = false;
              });
              $(".multiple-patchy-areas input[type=checkbox]").prop("checked", false);
              $(".fluffy-subpleural-peribronchiolar input[type=checkbox]").prop("checked", false);
        
              $(".severity-score-text").prop('disabled', false);
          } else {
              $(".severity-score-text").val(0);
              $("#total-severity-score").val(0);
              $("input[name=sectionA-findings]").val(["Multiple patchy areas of peripheral and central bilateral ground glass density with intra-lobular interstitial thickening (crazy paving) are seen in"]);
              $("input[name='Reverse halo sign or other signs of organizing pneumonia is']").val(["absent"]);
              $(".fluffy-subpleural-peribronchiolar input[type=checkbox]").prop("disabled", true);
        $(".multiple-patchy-areas input[type=checkbox]").prop("disabled", false);
              $(".severity-score-text").prop('disabled', true);
          }
  
  
      });
  
      $('#sectionA-multiple-patchy-areas').change(function () {
          if ($("#sectionA-multiple-patchy-areas").is(":checked")) {
              $(".severity-score-text").val(0);
              $("#total-severity-score").val(0);
              $(".severity-score-text").prop('disabled', true);
              $(".multiple-patchy-areas input[type=checkbox]").prop("disabled", false);
        $(".fluffy-subpleural-peribronchiolar input[type=checkbox]").prop("checked", false);
              $(".fluffy-subpleural-peribronchiolar input[type=checkbox]").prop("disabled", true);
          } else {
              $(".multiple-patchy-areas input[type=checkbox]").prop("disabled", false);
              $(".fluffy-subpleural-peribronchiolar input[type=checkbox]").prop("disabled", false);
              $(".severity-score-text").val(0);
              $("#total-severity-score").val(0);
              $(".severity-score-text").prop('disabled', false);
  
          }
      });
  
      $('#sectionA-fluffy-subpleural-peribronchiolar').change(function () {
          if ($("#sectionA-fluffy-subpleural-peribronchiolar").is(":checked")) {
              $(".severity-score-text").val(0);
              $("#total-severity-score").val(0);
              $(".severity-score-text").prop('disabled', true);
              $(".fluffy-subpleural-peribronchiolar input[type=checkbox]").prop("disabled", false);
        $(".multiple-patchy-areas input[type=checkbox]").prop("checked", false);
              $(".multiple-patchy-areas input[type=checkbox]").prop("disabled", true);
          } else {
              $(".multiple-patchy-areas input[type=checkbox]").prop("disabled", false);
              $(".fluffy-subpleural-peribronchiolar input[type=checkbox]").prop("disabled", false);
              $(".severity-score-text").val(0);
              $("#total-severity-score").val(0);
              $(".severity-score-text").prop('disabled', false);
  
          }
      });
  
      $(".fluffy-subpleural-peribronchiolar input[type=checkbox]").change(function (e) {
          if ($(this).is(":checked")) {
        if(! $("#sectionA-fluffy-subpleural-peribronchiolar").is(":checked")){
          $("#sectionA-fluffy-subpleural-peribronchiolar").prop("checked", true);
        }
              let value = $(this).val();
              switch (value) {
                  case 'right upper lobe':
                      $('#rul_score').prop('disabled', false);
                      break;
                  case 'right middle lobe':
                      $('#rml_score').prop('disabled', false);
                      break;
                  case 'right lower lobe':
                      $('#rll_score').prop('disabled', false);
                      break;
                  case 'left upper lobe':
                      $('#lul_score').prop('disabled', false);
                      break;
                  case 'left lower lobe':
                      $('#lll_score').prop('disabled', false);
                      break;
              }
          } else {
              let value = $(this).val();
              let total_val1 = $('#total-severity-score').val();
              switch (value) {
                  case 'right upper lobe':
                      let rul_val1 = $('#rul_score').val();
                      let new_total1 = total_val1 - rul_val1;
                      $('#rul_score').val(0)
                      $('#rul_score').prop('disabled', true);
                      $('#total-severity-score').val(new_total1);
                      break;
                  case 'right middle lobe':
                      let rml_val1 = $('#rml_score').val();
                      let new_total2 = total_val1 - rml_val1;
                      $('#rml_score').val(0)
                      $('#rml_score').prop('disabled', true);
                      $('#total-severity-score').val(new_total2);
                      break;
                  case 'right lower lobe':
                      let rll_val1 = $('#rll_score').val();
                      let new_total3 = total_val1 - rll_val1;
                      $('#rll_score').val(0)
                      $('#rll_score').prop('disabled', true);
                      $('#total-severity-score').val(new_total3);
                      break;
                  case 'left upper lobe':
                      let lul_val1 = $('#lul_score').val();
                      let new_total4 = total_val1 - lul_val1;
                      $('#lul_score').val(0)
                      $('#lul_score').prop('disabled', true);
                      $('#total-severity-score').val(new_total4);
                      break;
                  case 'left lower lobe':
                      let lll_val1 = $('#lll_score').val();
                      let new_total5 = total_val1 - lll_val1;
                      $('#lll_score').val(0)
                      $('#lll_score').prop('disabled', true);
                      $('#total-severity-score').val(new_total5);
                      break;
              }
          }
      });
  
      $(".multiple-patchy-areas input[type=checkbox]").change(function (e) {
          if ($(this).is(":checked")) {
        if(! $("#sectionA-multiple-patchy-areas").is(":checked")){
          $("#sectionA-multiple-patchy-areas").prop("checked", true);
        }
              let value = $(this).val();
  
              switch (value) {
                  case 'right upper lobe':
                      $('#rul_score').prop('disabled', false);
                      break;
                  case 'right middle lobe':
                      $('#rml_score').prop('disabled', false);
                      break;
                  case 'right lower lobe':
                      $('#rll_score').prop('disabled', false);
                      break;
                  case 'left upper lobe':
                      $('#lul_score').prop('disabled', false);
                      break;
                  case 'left lower lobe':
                      $('#lll_score').prop('disabled', false);
                      break;
              }
          } else {
              let value = $(this).val();
              let total_val2 = $('#total-severity-score').val();
              switch (value) {
                  case 'right upper lobe':
                      let rul_val2 = $('#rul_score').val();
                      let new_total6 = total_val2 - rul_val2;
                      $('#rul_score').val(0)
                      $('#rul_score').prop('disabled', true);
                      $('#total-severity-score').val(new_total6);
                      break;
                  case 'right middle lobe':
                      let rml_val2 = $('#rml_score').val();
                      let new_total7 = total_val2 - rml_val2;
                      $('#rml_score').val(0)
                      $('#rml_score').prop('disabled', true);
                      $('#total-severity-score').val(new_total7);
                      break;
                  case 'right lower lobe':
                      let rll_val2 = $('#rll_score').val();
                      let new_total8 = total_val2 - rll_val2;
                      $('#rll_score').val(0)
                      $('#rll_score').prop('disabled', true);
                      $('#total-severity-score').val(new_total8);
                      break;
                  case 'left upper lobe':
                      let lul_val2 = $('#lul_score').val();
                      let new_total9 = total_val2 - lul_val2;
                      $('#lul_score').val(0)
                      $('#lul_score').prop('disabled', true);
                      $('#total-severity-score').val(new_total9);
                      break;
                  case 'left lower lobe':
                      let lll_val2 = $('#lll_score').val();
                      let new_total0 = total_val2 - lll_val2;
                      $('#lll_score').val(0)
                      $('#lll_score').prop('disabled', true);
                      $('#total-severity-score').val(new_total0);
                      break;
              }
          }
      });
  
      $('#additional_findings_comment').attr('rows', 3);
      $('#additional_findings_comment').val(CT_VALIDATION_MESSAGE._iMessageCovidSrAdditionalFinding);
  
     $('#clinical-history').change(function() {
      if ( $('#clinical-history').val() == 'RTPCR positive for Covid.'){
        $("input[name=corads]").val(['CORADS-6']);
      }
      else
      {
        $('input:radio[name="corads"][value="CORADS-6"]').prop('checked',false);
      }
    });
  }

export const regenerateHRCTCovidReport = () => {
        sentences = new Map();
    
        let ct_severity_score_array = [];
        let corads_table = []
        let ct_severity_table = [];
        
        setSeverity();
        getClinicalHistory()
        getFindingsAndSectionsSelected();
        getSelectedCorad();
        getAdditionalFindings();
    
        let validationResults = validateResults();
        if (validationResults != null) {
            //alert(validationResults.message);
           // showAlert(validationResults.message, function () {});
          // CovidSRPopupCloseAction(); 
          return {error:true, message: validationResults.message};
            //return null;
        }
    
    
        ct_severity_score_array.push($('#total-severity-score').val())
        sentences["CT Severity Score"] = ct_severity_score_array;
    
        let rul_score = $("#rul_score").val();
        let rml_score = $("#rml_score").val();
        let rll_score = $("#rll_score").val();
        let lul_score = $("#lul_score").val();
        let lll_score = $("#lll_score").val();
        let total_score = $("#total-severity-score").val();
    
        $("#rul_score").replaceWith(rul_score);
        $("#rml_score").replaceWith(rml_score);
        $("#rll_score").replaceWith(rll_score);
        $("#lul_score").replaceWith(lul_score);
        $("#lll_score").replaceWith(lll_score);
        $("#total-severity-score").replaceWith(total_score);
        $("#ct-severity-score-table td").css('height','auto','text-align','center');
        ct_severity_table.push($('#ct-severity-score-table-div').html());
    
        $("#corads-1").remove();
        $("#corads-2").remove();
        $("#corads-3").remove();
        $("#corads-4").remove();
        $("#corads-5").remove();
        $("#corads-6").remove();
        $("#corads-table td").css('height','auto','text-align','center');
        switch (selectedCorad) {
    
            case "CORADS-1":
                corads_table.push($('#corads-1-row').html());
                break;
    
            case "CORADS-2":
                corads_table.push($('#corads-2-row').html());
                break;
            case "CORADS-3":
                corads_table.push($('#corads-3-row').html());
                break;
            case "CORADS-4":
                corads_table.push($('#corads-4-row').html());
                break;
            case "CORADS-5":
                corads_table.push($('#corads-5-row').html());
                break;
            case "CORADS-6":
                corads_table.push($('#corads-6-row').html());
                break;
        }
     
        sentences['CT Severity Score Table'] = ct_severity_table;
        if (Array.isArray(corads_table) && corads_table.length) {
        sentences['CORADS Table'] = corads_table;
    }
        //event.preventDefault();
        //event.stopPropagation();
    
        console.log(sentences);
        let submittedValues = JSON.stringify(sentences);
    
        const covidSRForm = $("form[name='form_hrct_covid_sr']");
        let covidSRData = covidSRForm.serializeArray();
        covidSRData.push({
            name: 'values',
            value: submittedValues
        })
    
        covidSRData.push({
            name : 'templateName',
            value: 'covid_sr'
        });
        return covidSRData;
    }



function setSeverity() {
    let severity_array = [];
	let total__severity_score =  $("#total-severity-score").val();
    if (total__severity_score <= 8)
        severity = COVID_SR_MESSAGE._iMessageCovidMild;
    else if (8 < total__severity_score && total__severity_score <= 15)
        severity = COVID_SR_MESSAGE._iMessageCovidModerate;
    else
        severity = COVID_SR_MESSAGE._iMessageCovidSevere;

    console.log("Severity : " + severity);
    severity_array.push(severity);
    sentences["Severity"] = severity_array;
}


function getClinicalHistory() {
    let clinical_history = $("#clinical-history").val();
    let clinical_historyComment = $("#clinical-history_comment").val();
    let sentencesA = [];
    if (clinical_history !== null && clinical_history !== undefined && clinical_history !== 'Other') {
        sentencesA.push(clinical_history);
    }
    if (clinical_historyComment !== null && clinical_historyComment !== undefined && clinical_historyComment !== "") {
        sentencesA.push("(" + clinical_historyComment + ".)");
    }
    sentences['Clinical History'] = sentencesA;
}

function getAdditionalFindings() {
    let additional_findings = $("#additional_findings_comment").val();
    let sentencesArray = [];
    if (additional_findings !== null && additional_findings !== undefined && additional_findings !== "") {
        let arr_new = additional_findings.trim().split(".")
        for (let i = 0; i < arr_new.length; i++) {
            if (arr_new[i] !== "")
                sentencesArray.push(arr_new[i] + ".");
        }
        sentences['Additional Findings'] = sentencesArray;
    }

}

function getFindingsAndSectionsSelected() {
    let sectionSelected = false;
    let sectionName = [];
    let areas = [];
    let sentences_findings = [];
    if ($("#sectionAdiv input[type=radio]:checked").length > 0) {
        $("#sectionAdiv input[type=radio]:checked").each(function () {
            if ($(this).attr('name') === 'sectionA-findings') {
                let sentence = $(this).val();
                if (sentence.includes('patchy areas')) {
                    $("input:checkbox[name=multiple-patchy-areas]:checked").each(function () {
                        areas.push($(this).val());
                    });
                } else {
                    $("input:checkbox[name=fluffy-subpleural-peribronchiolar]:checked").each(function () {
                        areas.push($(this).val());
                    });
                }
                let clause = areas[0];
                if (areas.length > 2) {
                    for (let i = 1; i < areas.length - 1; i++) {
                        clause = clause + ", " + areas[i];
                    }
                }
                if (areas.length >= 2) {
                    clause = clause + " and " + areas[areas.length - 1] + ".";
                }
                if (areas.length == 1) {
                    clause = clause + ".";
                }
                sentence = sentence + " " + clause;
                sentences_findings.push(sentence);
            } else {
                let sents = [];
                if ($(this).val() === 'present') {
                    sents.push($(this).val());
                    let sent = $(this).attr('name');
                    sent = sent + " " + sents[0] + ".";
                    sentences_findings.push(sent);
                }
            }
        });
        sentences_findings.push(COVID_SR_MESSAGE._iMessageCovidSectionAFinding);
        sectionSelected = true;
        sectionName.push("sectionA");
        sectionSelectedName = "sectionA";
    } else {
        if (!sectionSelected) {
            $("input:checkbox[name=sectionB-findings]:checked").each(function () {
                sentences_findings.push($(this).val());
            });
        }
        sectionSelected = true;
        sectionName.push("sectionB");
        sectionSelectedName = "sectionB";
    }
    sentences['Findings'] = sentences_findings;
    sentences['Section selected'] = sectionName;
}

function getSelectedCorad() {
    let corads = []
    selectedCorad = $("input:radio[name=corads]:checked").val();
	if(selectedCorad != null && selectedCorad != undefined && selectedCorad != ""){
	corads.push(selectedCorad);
    sentences['CORADS'] = corads;

	}
}

function validateResults() {
    
    let clinical_history = $("#clinical-history").val();
    let clinical_historyComment = $("#clinical-history_comment").val();
    let selectedCorad = $("input:radio[name=corads]:checked").val();

	if ($("#sectionAdiv input[type=radio]:checked").length > 0) {
		sectionSelectedName = "sectionA";
	}else{
		sectionSelectedName = "sectionB";
	}
	
    if (clinical_history === 'Other' && (clinical_historyComment == null || clinical_historyComment == undefined || clinical_historyComment == "")) {
        return {
            error: 1,
            message: COVID_SR_MESSAGE._iMessageCovidClinicalHistoryOtherError
        };
    }

    let sectionAfinding = $("input[name='sectionA-findings']:checked").val();
    if (sectionSelectedName == "sectionA") {
        if (sectionAfinding.includes('patchy areas')) {
            let count = $("input:checkbox[name=multiple-patchy-areas]:checked").length;
            if (count == 0) {
                return {
                    error: 1,
                    message: COVID_SR_MESSAGE._iMessageCovidOptionsNotSelectedError
                };
            }
        } else {
            let count = $("input:checkbox[name=fluffy-subpleural-peribronchiolar]:checked").length;
            if (count == 0) {
                return {
                    error: 1,
                    message: COVID_SR_MESSAGE._iMessageCovidOptionsNotSelectedError
                };
            }
        }

        let reverse_halo_sign = $("input[name='Reverse halo sign or other signs of organizing pneumonia is']:checked").val();
        if (sectionAfinding !== null && sectionAfinding !== undefined && (reverse_halo_sign == null || reverse_halo_sign == undefined)) {
            return {
                error: 1,
                message: COVID_SR_MESSAGE._iMessageCovidReverseHaloSignError
            };
        }
    }

    let sectionBfindings = $("input:checkbox[name=sectionB-findings]:checked").length;
    if (sectionAfinding !== null && sectionAfinding !== undefined && sectionBfindings !== null & sectionBfindings > 0) {
        return {
            error: 1,
            message: COVID_SR_MESSAGE._iMessageCovidSectionError
        };
    }


    if ((sectionSelectedName ==='sectionA' && (selectedCorad == null || selectedCorad == undefined || selectedCorad == ""))  || (sectionSelectedName ==='sectionB' && clinical_history != 'RTPCR negative.' && (selectedCorad == null || selectedCorad == undefined || selectedCorad == ""))) {
        return {
            error: 1,
            message: COVID_SR_MESSAGE._iMessageCovidCoradsError
        };
    }
    return null;
}